// AUTO-GENERATED by `npm run codegen:ui` - do not edit.
namespace $ {

export type easyreels_user_upload_completeMutationVariables = Exact<{
  input: CompleteFileUploadInput;
}>;


export type easyreels_user_upload_completeMutation = { __typename?: 'Mutation', completeFileUpload: { __typename: 'CompleteFileUploadPayload', recording: { __typename?: 'Recording', id: number } } | { __typename: 'ErrorPayload', message: string } };


export function $easyreels_user_upload_complete(variables: easyreels_user_upload_completeMutationVariables, opts?: { revalidate?: boolean }): easyreels_user_upload_completeMutation {
	return $easyreels_gql_user_request(`mutation easyreels_user_upload_complete(\u0024input: CompleteFileUploadInput!) {
  completeFileUpload(input: \u0024input) {
    __typename
    ... on CompleteFileUploadPayload {
      recording {
        id
      }
    }
    ... on ErrorPayload {
      message
    }
  }
}`, variables, opts) as easyreels_user_upload_completeMutation
}

}
